import type { FC } from 'react';
import { PulseButton } from '@anywayseo/tools';
import { DownloadIcon } from '@chakra-ui/icons';
import { Button, Flex, Link, Text } from '@chakra-ui/react';

const HeaderToolbar: FC = () => {
  const linkUrl = process.env.GATSBY_SITE_REF_LINK;

  return (
    <Flex gap={2} align='center'>
      {linkUrl && (
        <Button as={Link} href={linkUrl} aria-label='Download' target='_blank' rel='noopener noreferrer' h='100%'>
          <DownloadIcon />
          <Text display={{ base: 'none', md: 'block' }} ms={2}>
            Download
          </Text>
        </Button>
      )}
      {linkUrl && <PulseButton label='ANMELDEN' to={linkUrl} />}
    </Flex>
  );
};

export default HeaderToolbar;
